var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"filter-boolean"}},[_c('checkbox-field',{attrs:{"name":_vm.filter.text},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }